import View from '../core/View';
import LibraryCatalogToolbarView from './LibraryCatalogToolbarView';
import CatalogListView from './CatalogListView';

export default class PDFView extends View {

    createView(model) {

        let libraryCatalog = model['libraryCatalog'];
        let url = model['url'];
        let visualTemplate = model['visualTemplate'];

        let pdfDOM = $('<div>', {
            css: {
                'margin': '0px',
                'padding': '0px',
                'height': '100%',
                'overflow-y': 'hidden'
            }
        });

        let toolbar = undefined;

        if (libraryCatalog.showCatalogMenu) {
            toolbar = this.app.createView(new LibraryCatalogToolbarView(), {
                'libraryCatalog': libraryCatalog,
                'visualTemplate': visualTemplate
            }).appendTo(pdfDOM);
        }

        let pdfviewerHeight = $(window).height() - ((toolbar) ? toolbar.height() : 0);

        let iframe = $('<iframe>', {
            src: 'lib/pdfjs/web/viewer.html?file=' + encodeURI(url),
            css: {
                'border': 'none',
                'width': '100%',
                'min-height': pdfviewerHeight+'px'
            }
        }).appendTo(pdfDOM);

        $(window)
            .resize(() => {
                let pdfviewerHeight = $(window).height() - ((toolbar) ? toolbar.height() : 0);
                iframe.css({
                    'width': '100%',
                    'min-height': pdfviewerHeight+'px'
                });
            });

        //let canvas = $('<canvas>', {
        //    class: 'pdf',
        //    style: 'min.width: 100%; min-height: 100%;'
        //}).appendTo(pdfDOM);
        //
        //canvas[0].width = window.innerWidth;
        //canvas[0].height = window.innerHeight;
        //
        //var context = canvas[0].getContext('2d');
        //
        //console.log(canvas);
        //var desiredWidth = window.innerWidth;
        //var viewport = page.getViewport(1);
        //console.log(viewport);
        //var scale = desiredWidth / viewport.width;
        //console.log(scale);
        //var scaledViewport = page.getViewport(scale);
        //console.log(scaledViewport);
        //
        //canvas[0].height = scaledViewport.height;
        //
        //var renderContext = {
        //    canvasContext: context,
        //    viewport: scaledViewport
        //};
        //page.render(renderContext);

        return pdfDOM;

    }

}